import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import RestaurantPage from './pages/RestaurantPage';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';

/**
 * App — Root component
 * 
 * Marketing pages (/, /services, /pricing, /contact) render full-width.
 * Restaurant pages (/r/:slug) render inside the 480px phone container.
 */

function AppContent() {
  const location = useLocation();
  const isRestaurantPage = location.pathname.startsWith('/r/');

  return (
    <>
      {isRestaurantPage ? (
        /* Restaurant pages — phone-sized container */
        <div className="app-container">
          <Routes>
            <Route path="/r/:slug/*" element={<RestaurantPage />} />
          </Routes>
        </div>
      ) : (
        /* Marketing pages — full width, no container constraint */
        <div className="marketing-root">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;